import { Text, View } from "react-native";
import { ChevronRight, Plus, TestTube2 } from "lucide-react-native";
import { useTranslations } from "@src/packages/i18n";
import { CardSurface, CompactActionButton } from "@louise/moon-ui";
import { semanticColors } from "@louise/theme/tokens";

export default function TestResultActionsCard({
  addResultDescription,
  getTestedDescription,
  onAddResult,
  onGetTested,
  t,
}: {
  addResultDescription: string;
  getTestedDescription: string;
  onAddResult: () => void;
  onGetTested: () => void;
  t: ReturnType<typeof useTranslations>;
}) {
  return (
    <CardSurface style={{ padding: 14 }}>
      <View style={{ gap: 8 }}>
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 13,
            lineHeight: 19,
            color: semanticColors.text.tertiary,
          }}
        >
          {addResultDescription}
        </Text>
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 13,
            lineHeight: 19,
            color: semanticColors.text.tertiary,
          }}
        >
          {getTestedDescription}
        </Text>
      </View>

      <View style={{ flexDirection: "row", gap: 8, marginTop: 14 }}>
        <View style={{ flex: 1 }}>
          <CompactActionButton
            label={t("access.testing.comparison.add_result")}
            leadingIcon={Plus}
            variant="secondary"
            action="test_result_action"
            onPress={onAddResult}
          />
        </View>
        <View style={{ flex: 1 }}>
          <CompactActionButton
            label={t("access.testing.comparison.get_tested")}
            leadingIcon={TestTube2}
            trailingIcon={ChevronRight}
            variant="secondary"
            action="test_result_action"
            onPress={onGetTested}
          />
        </View>
      </View>
    </CardSurface>
  );
}
